import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';
import { FilterService } from 'src/app/services/filter.service';
import { CommentsNotesService } from './comments-notes.service';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import moment from 'moment';
import { PopupDeleteComponent } from '../popup-delete/popup-delete.component';
import { DashboardService } from 'src/app/services/dashboard.service';
import { HashtagService } from './hashtag.service';

@Component({
  selector: 'app-expand-thread',
  template: `
  <style>
    .du-notes-font-style {
      font-family: 'Poppins';
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: #101D42;
    }

    .font-family {
      font-family: 'Poppins';
    }

    .note-card {
        border-radius: 12px;
        border: 1px solid #E8EAEE;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        position: relative;
        font-family: 'Poppins';
        transition: 1s ease-in-out !important;
    }

    .note-header {
        display: flex;
        align-items: center;
        position: relative;
        font-family: 'Poppins';
        gap: 10px;
    }

    .avatar {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 2px solid #ffffff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .expanded-avator {
        position: absolute;
        left: -17px;
        z-index: 99;
    }


    .timestamp {
        font-size: 12px;
        color: #101D42;
        font-family: 'Poppins';
        font-weight: 500;
        line-height: 16px;
    }

    .timestamp-du-notes {
        font-size: 10px;
        color: #737D88;
        font-family: 'Poppins';
        font-weight: 500;
        line-height: 16px;
    }

    .du-notes-employee-name {
        font-size: 12px;
        color: #101D42;
        font-family: 'Poppins';
        font-weight: 600;
        line-height: 16px;
    }

    
    .note-content {
        font-family: 'Poppins';
        color: #101D42;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        white-space: pre-wrap;
        word-wrap: break-word !important;
        overflow-wrap: break-word;
        word-break: break-word;
        max-width: 100%;
    }

    .du-notes-header {
        font-family: 'Poppins';
        font-size: 18px;
        font-weight: 600;
        line-height: 27px;
        text-decoration-skip-ink: none;
        color: #101D42;
    }

    .du-mat-icons-notes-header {
        height: 30px;
        width: 30px;
        cursor: pointer !important;
    }
    .group-connector {
      width: 2px;
      background-color: #D4D9E3;
      margin-left: -9px;
      display: block;
      height: 100%;
      position: absolute;
      z-index: 9;
      top: 47px;
    }

    /* Full height for the whole dialog */
    ::ng-deep .du-notes-expand-thread-dialog .mat-dialog-container {
      height: 90dvh !important;
      max-height: 90dvh !important;
      width: 100vw !important;
      max-width: 100vw !important;
      margin: 0 !important;
      overflow: hidden !important;
      box-sizing: border-box !important;

      /* display: flex !important;
      flex-direction: column !important; */
      padding: 0 !important;
    }

    /* Make your outer wrapper fill height */
    .du-notes-expand-thread {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      max-width: 100%;
      box-sizing: border-box;
    }

    /* Content scrolls inside */
    ::ng-deep .du-notes-expand-thread-dialog .mat-dialog-content {
      flex: 1 1 auto;
      overflow: auto !important;
      max-height: none !important;
    }

    ::ng-deep .du-notes-expand-thread-dialog .du-notes-expand-thread > mat-dialog-content {
      flex: 1 1 auto;           /* take remaining height */
      overflow: auto !important;
      max-height: none !important;
      width: 100%;              /* avoid shrinking to the left */
    }
/* 
    ::ng-deep .du-notes-expand-thread .mat-dialog-content {
      padding: 0 5px 20px;
      margin: 0 15px !important;
      overflow: auto;
      height: calc(100vh - 150px) !important;
      height: calc(100dvh - 150px) !important;
      max-height: 100% !important;
    } */
    /* width */
    ::ng-deep .du-notes-expand-thread .mat-dialog-content::-webkit-scrollbar {
        width: 4px;
        background: #E8EAEE !important;
        cursor: pointer;
    }
    ::ng-deep .du-notes-expand-thread .mat-dialog-content
    /* Track */
    ::ng-deep .du-notes-expand-thread .mat-dialog-content::-webkit-scrollbar-track {
        background: #E8EAEE !important;
    }

    /* Handle */
    ::ng-deep .du-notes-expand-thread .mat-dialog-content::-webkit-scrollbar-thumb {
        background: #8A98AB !important;
        border-radius: 8px;
    }

    /* Handle on hover */
    ::ng-deep .du-notes-expand-thread .mat-dialog-content::-webkit-scrollbar-thumb:hover {
        background: #8A98AB !important;
    }

    /* width */
    ::ng-deep .du-notes-expand-thread .mat-dialog-content::-webkit-scrollbar {
        width: 4px;
        background: #E8EAEE !important;
        cursor: pointer;
    }
    .du-notes-heading-expand-thread {
      font-size: 16px;
      font-weight: 600;
      font-family: 'Poppins';
      line-height: 24px;
    }
    .du-notes-expand-thread-close-icon {
      color: #8a98ab;
      cursor: pointer !important;
    }
    .du-notes-about-style {
      font-family: 'Poppins';
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      color: #737D88;
    }
    
    .du-notes-sp-input {
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 14px;
        color: #333;
        background: none;
        resize: none;
        padding-left: 10px;
        width: 100%;
        font-family: 'Poppins';
    }

    .du-notes-sp-input::placeholder {
        color: #b0b0b0;
    }

    /* width */
    .du-notes-sp-input::-webkit-scrollbar {
        width: 4px;
        background: #E8EAEE !important;
        cursor: pointer;
    }

    /* Track */
    .du-notes-sp-input::-webkit-scrollbar-track {
        background: #E8EAEE !important;
    }

    /* Handle */
    .du-notes-sp-input::-webkit-scrollbar-thumb {
        background: #8A98AB !important;
        border-radius: 8px;
    }

    /* Handle on hover */
    .du-notes-sp-input::-webkit-scrollbar-thumb:hover {
        background: #8A98AB !important;
    }


    .du-notes-sp-input-edited {
      padding: 10px;
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      font-size: 12px;
      font-family: 'Poppins';
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    .du-notes-you {
        margin-left: 5px;
        font-weight: 500;
        font-size: 12px;
        font-family: 'Poppins';
        color: #1363DF !important;
    }

    .du-notes-edited {
        margin-left: 5px;
        font-weight: 500;
        font-size: 10px;
        font-family: 'Poppins';
        color: #737D88 !important;
    }

    .hashtags {
      font-size: 12px;
      color: #1363DF;
    }

    ::ng-deep .du-note-hashtag-expand mat-chip-list .mat-chip-list-wrapper {
        margin: 0px !important;
    } 

    ::ng-deep .du-note-hashtag-expand mat-chip-list .mat-chip-list-wrapper mat-chip.mat-chip {
        min-height: 20px !important;
        padding: 3px 5px !important;
        margin: 1px !important;
    } 

    ::ng-deep .du-note-hashtag-expand mat-chip-list .mat-chip-list-wrapper mat-chip.mat-chip .mat-chip-remove mat-icon {
        width: 15px !important;
        height: 15px !important;
        font-size: 15px !important;
    } 

    ::ng-deep .du-note-hashtag-expand mat-chip-list .mat-chip-list-wrapper mat-chip.mat-chip .mat-chip-remove {
        width: 15px !important;
        height: 15px !important;
    } 
  </style>
  <div class="du-notes-expand-thread p-2">
    <div class="d-flex align-items-center justify-content-between p-2">
      <div>
        <div class="du-notes-heading-expand-thread">{{paramsData.key}}</div>
        <div *ngIf="this.hashtags?.length>0" class="du-note-hashtag-expand">
            <mat-chip-list #chipList aria-label="chip selection">
                <mat-chip
                  class="hashtags"
                  *ngFor="let hash of this.hashtags;"
                  (removed)="remove(hash)">
                  {{hash}}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
            </mat-chip-list>
        </div>
      </div>
      <span class="d-flex align-items-center" style="gap: 10px;">
        <span (click)="orderBy()" matTooltip="Sort" mat-icon-button>
            <span *ngIf="this.order=='desc'" style="cursor: pointer;">
                <svg width="31" height="31" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M27 14C27 6.8203 21.1797 1 14 1C6.8203 1 1 6.8203 1 14C1 21.1797 6.8203 27 14 27C21.1797 27 27 21.1797 27 14Z" fill="white" stroke="#E8EAEE" stroke-width="2"/>
                    <path d="M10.573 9.17597L8.17551 11.576L8.12563 11.6325C7.94274 11.868 7.95956 12.2083 8.17596 12.4245L8.23251 12.4744C8.46798 12.6572 8.80832 12.6404 9.02449 12.424L10.4006 11.046V18.0004L10.4046 18.0704C10.4393 18.3688 10.6929 18.6004 11.0006 18.6004L11.0706 18.5963C11.369 18.5617 11.6006 18.3081 11.6006 18.0004V11.0502L12.9766 12.4245L13.0332 12.4744C13.2687 12.6573 13.609 12.6404 13.8252 12.424C14.0593 12.1895 14.059 11.8096 13.8246 11.5755L11.4215 9.17547L11.3649 9.1256C11.1294 8.94275 10.7891 8.95958 10.573 9.17597Z" fill="#1363DF"/>
                    <path d="M17.4276 18.4244L19.8251 16.0244L19.875 15.9679C20.0578 15.7324 20.041 15.3921 19.8246 15.1759L19.7681 15.126C19.5326 14.9432 19.1923 14.96 18.9761 15.1764L17.6 16.5544V9.6L17.596 9.53C17.5613 9.2316 17.3077 9 17 9L16.93 9.0041C16.6316 9.0387 16.4 9.2923 16.4 9.6V16.5502L15.024 15.1759L14.9674 15.126C14.7319 14.9431 14.3916 14.96 14.1754 15.1764C13.9413 15.4109 13.9416 15.7908 14.176 16.0249L16.5791 18.4249L16.6357 18.4748C16.8712 18.6577 17.2115 18.6408 17.4276 18.4244Z" fill="#A0B0C8"/>
                </svg>
            </span>

            <span *ngIf="this.order=='asc'" style="cursor: pointer;">
                <svg width="31" height="31" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 14C1 21.1797 6.8203 27 14 27C21.1797 27 27 21.1797 27 14C27 6.8203 21.1797 1 14 1C6.8203 1 1 6.8203 1 14Z" fill="white" stroke="#E8EAEE" stroke-width="2"/>
                    <path d="M17.427 18.824L19.8245 16.424L19.8744 16.3675C20.0573 16.132 20.0404 15.7917 19.824 15.5755L19.7675 15.5256C19.532 15.3428 19.1917 15.3596 18.9755 15.576L17.5994 16.954V9.99959L17.5954 9.92959C17.5607 9.63119 17.3071 9.39959 16.9994 9.39959L16.9294 9.40369C16.631 9.43829 16.3994 9.69189 16.3994 9.99959V16.9498L15.0234 15.5755L14.9668 15.5256C14.7313 15.3427 14.391 15.3596 14.1748 15.576C13.9407 15.8105 13.941 16.1904 14.1754 16.4245L16.5785 18.8245L16.6351 18.8744C16.8706 19.0572 17.2109 19.0404 17.427 18.824Z" fill="#1363DF"/>
                    <path d="M10.5724 9.57556L8.17493 11.9756L8.12505 12.0321C7.94216 12.2676 7.95898 12.6079 8.17538 12.8241L8.23193 12.874C8.4674 13.0568 8.80774 13.04 9.02391 12.8236L10.4 11.4456V18.4L10.404 18.47C10.4387 18.7684 10.6923 19 11 19L11.07 18.9959C11.3684 18.9613 11.6 18.7077 11.6 18.4V11.4498L12.976 12.8241L13.0326 12.874C13.2681 13.0569 13.6084 13.04 13.8246 12.8236C14.0587 12.5891 14.0584 12.2092 13.824 11.9751L11.4209 9.57506L11.3643 9.52519C11.1288 9.34234 10.7885 9.35917 10.5724 9.57556Z" fill="#A0B0C8"/>
                </svg>
            </span>
        </span>
        <mat-icon (click)="deleteCommentToClose()" class="du-notes-expand-thread-close-icon">close</mat-icon>
      </span>
    </div>
    <hr>
    <mat-dialog-content class="mat-typography">
      <div *ngIf="groupedMessages.length==0 || checkAllHaveTheMessages(groupedMessages)" style="height: 150px;align-content: center;text-align: center;">
          <p style="font-family: 'Poppins;font-size: 14px'; font-weight: 600px;"> No data </p>
      </div>
      <div *ngIf="groupedMessages.length>0">
        <div *ngFor="let group of groupedMessages; let i = index; let isLast = last" class="du-global-notes-under-dashboard">
          <ng-containter *ngIf="group.messages?.length>0">
            <mat-accordion>
              <mat-expansion-panel hideToggle="true" #expensionComments [expanded]="filterArrayCount(isLast)">
                  <mat-expansion-panel-header>
                    <div class="d-flex align-items-center" style="gap: 5px;">
                      <span class="tree-dot" *ngIf="expensionComments.expanded">
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="6" cy="6" r="5.5" fill="white" stroke="#8A98AB"/>
                              <path d="M5.45455 5.45533H3.40909C3.18327 5.45533 3 5.6386 3 5.86442V6.13713C3 6.36295 3.18327 6.54622 3.40909 6.54622H5.45455C5.5 6.54622 5.63782 6.54622 5.86364 6.54622H6.13636C6.36218 6.54622 6.5 6.54622 6.54545 6.54622H8.59091C8.81673 6.54622 9 6.36295 9 6.13713V5.86442C9 5.6386 8.81673 5.45533 8.59091 5.45533H6.54545C6.13636 5.45549 6.36218 5.45508 6.13636 5.45508L5.86364 5.45533C5.63782 5.45533 5.5 5.45533 5.45455 5.45533Z" fill="#8A98AB"/>
                          </svg>                                        
                      </span>
                      <span class="tree-dot" *ngIf="!expensionComments.expanded">
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="6" cy="6" r="5.5" fill="white" stroke="#E8EAEE"/>
                              <path d="M5.45455 3.40909V5.45455H3.40909C3.18327 5.45455 3 5.63782 3 5.86364V6.13636C3 6.36218 3.18327 6.54545 3.40909 6.54545H5.45455V8.59091C5.45455 8.81673 5.63782 9 5.86364 9H6.13636C6.36218 9 6.54545 8.81673 6.54545 8.59091L6.54545 6.54545H8.59091C8.81673 6.54545 9 6.36218 9 6.13636V5.86364C9 5.63782 8.81673 5.45455 8.59091 5.45455H6.54545L6.54545 3.40909C6.54545 3.18327 6.36218 3 6.13636 3L5.86364 3C5.63782 3 5.45455 3.18327 5.45455 3.40909Z" fill="#8A98AB"/>
                          </svg>                                        
                      </span>
  
                      <!-- Header -->
                      <span class="font-family my-2 du-notes-font-style" style="font-weight: 500 !important;">{{ group.group }}</span>
                    </div>
                  </mat-expansion-panel-header>
  
                  <div class="note-card mb-2" *ngFor="let message of group.messages; let idx = index;" >
                      <div class="p-3">
                          <div style="font-size: 12px;color: #8d8b8b;font-family: 'Poppins'!important;">
                            <p *ngIf="!editEnabled || editIndex!=(i+'-'+idx)" class="note-content font-family" [innerHtml]="getMSGHtml(message.comments)"></p>
                            <textarea  
                                *ngIf="editEnabled && editIndex==(i+'-'+idx)"
                                #editTextArea
                                id="editTextArea"
                                rows="4" cols="33" 
                                maxlength="250" 
                                class="du-notes-sp-input du-notes-sp-input-edited font-family"
                                [(ngModel)]="editedValue" 
                                type="text"
                                placeholder="Write note ..." 
                                (keydown.enter)="saveEdit($event, message, i, idx)"
                                [value]="message.comments"
                            >
                            </textarea>
                            <div *ngIf="editEnabled && editIndex==(i+'-'+idx)" style="width: 100%;font-size: 9px;line-height: 0px;margin-top: 4px;text-align: right;" >{{editedValue.length+'/250'}}</div>
                            <div style="width: 100%;display: flex;justify-content: flex-end;">
                                <span *ngIf="editEnabled && editIndex==(i+'-'+idx) && editedValue==''" style="color: #d02e2e;margin: auto;">Please type a message to continue</span>
                                
                                <button mat-icon-button *ngIf="editEnabled && editIndex==(i+'-'+idx)" color="primary" (click)="saveEdit($event, message, i, idx)">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button mat-icon-button *ngIf="editEnabled && editIndex==(i+'-'+idx)" color="primary" (click)="editEnabled=false">
                                <mat-icon>close</mat-icon>
                                </button>
                            </div>
                          </div>
                  
                          <div class="note-header">
                              <div class="avatar-wrapper">
                                  <img src="../../../../assets/generic_gender.png" alt="User Avatar" class="avatar">
                              </div>
                              <!-- <div>
                                  <div class="du-notes-employee-name">{{ message.employee_name }}</div>
                                  <div class="timestamp-du-notes">{{ message.insert_timestamp | date: 'MMM d, y, h:mm a' }}</div>
                              </div> -->
                              <div>
                                <div class="du-notes-employee-name">
                                    <span>{{ message.employee_name }}</span>
                                    <span *ngIf="message.employee_key==employee_key" class="du-notes-you">{{ '(You)' }}</span>
                                    <span *ngIf="message.update_timestamp" class="du-notes-edited">{{ 'edited' }}</span>
                                </div>
                                <div class="timestamp-du-notes">
                                    <span *ngIf="message.update_timestamp">
                                        {{ message.update_timestamp | date: 'MMM d, y, h:mm a' }}
                                    </span>
                                    <span *ngIf="!message.update_timestamp">
                                        {{ message.insert_timestamp | date: 'MMM d, y, h:mm a' }}
                                    </span>
                                </div>
                              </div>
                          </div>
  
                          <div class="mt-2">
                              <hr>
                              <div class="d-flex align-items-center justify-content-between">
                                  <div class="du-notes-about-style">About: <span class="du-notes-font-style du-notes-dashboard-name">{{ message.conversation_key }}</span></div>
                                  
                                  <span [matMenuTriggerFor]="editAndDelete" style="cursor: pointer;padding: 0 5px;" *ngIf="message.employee_key==employee_key">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="221.156 82.028 3 12" width="3px" height="12px">
                                          <path d="M 224.156 83.528 C 224.156 82.7 223.484 82.028 222.656 82.028 C 221.828 82.028 221.156 82.7 221.156 83.528 C 221.156 84.357 221.828 85.028 222.656 85.028 C 223.484 85.028 224.156 84.357 224.156 83.528 Z" fill="#1363DF"/>
                                          <path d="M 221.156 88.028 C 221.156 87.2 221.828 86.528 222.656 86.528 C 223.484 86.528 224.156 87.2 224.156 88.028 C 224.156 88.857 223.484 89.528 222.656 89.528 C 221.828 89.528 221.156 88.857 221.156 88.028 Z" fill="#1363DF"/>
                                          <path d="M 221.156 92.528 C 221.156 91.7 221.828 91.028 222.656 91.028 C 223.484 91.028 224.156 91.7 224.156 92.528 C 224.156 93.357 223.484 94.028 222.656 94.028 C 221.828 94.028 221.156 93.357 221.156 92.528 Z" fill="#1363DF"/>
                                      </svg>
                                  </span>
  
                                  <mat-menu #editAndDelete="matMenu" xPosition="before">
                                    <button mat-menu-item style="text-align: left;" type="button" (click)="editComment($event, message, i, idx)">
                                      <mat-icon style="width: 20px;" svgIcon="edit"></mat-icon>
                                      <span style="font-family: 'poppins';font-size: 12px;">Edit</span>
                                    </button>
                                    
                                    <button mat-menu-item style="text-align: left;" type="button" (click)="deleteComment($event, message, i, idx)">
                                      <mat-icon style="width: 20px;" svgIcon="delete"></mat-icon>
                                      <span style="font-family: 'poppins';font-size: 12px;">Delete</span>
                                    </button>
                                  </mat-menu>
                              </div>
                          </div>
                      </div>
                  </div>
  
                  <div class="group-connector"></div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-containter>
        </div>  
      </div>
    </mat-dialog-content>
  </div>

  `,
})
export class ExpandThreadComponent implements OnInit {

  paramsData:any;
  groupedMessages: any[] = [];
  datewiseGroupObj:any = {};
  stateForToggleObj:any = {};
  employee_key:any;
  
  editEnabled = false;
  editIndex:any;
  editedValue:any;
  hashtags:any = [];
  order:any = 'desc';
  reqSubcription: Subscription[] = [];
  filteredData:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private dialogRef: MatDialogRef<ExpandThreadComponent>,
    public filterService: FilterService,
    private commentsNotesService: CommentsNotesService,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private dashboardService: DashboardService,
    private hashtagService: HashtagService
  ) {
    let empkey = sessionStorage.getItem('employee_key');
    if (empkey) {
      const parsedEmpkey: any = JSON.parse(empkey);
      this.employee_key = parsedEmpkey._value;
    }

    this.paramsData = passedData

    if(this.paramsData) {
      this.filteredData = this.paramsData?.value.filter((f:any)=> f.conversation_key == this.paramsData.key);

      let fndHashTag = this.paramsData?.hashtags.find((f:any)=> f.hashtag_type + " - " + f.hashtag_key == this.paramsData.key);
      if(fndHashTag?.hashtag_value) {
        this.hashtags = fndHashTag?.hashtag_value?.split(',') || [];
      }

      this.commentsNotesService.modalData = {"U": [],"D": [], "key": this.paramsData.key, "hash": this.hashtags}
      this.groupedMessages = this.commentsNotesService.groupMessagesByOutlookFormat(this.filteredData, this.order);
    }
  }

  orderBy() {
    this.order = (this.order == 'desc') ? 'asc' : 'desc';
    this.groupedMessages = this.commentsNotesService.groupMessagesByOutlookFormat(this.filteredData, this.order);
  }

  ngOnInit() {}

  filterArrayCount(isLast:any) {
    let flrMsg = this.groupedMessages.filter((f:any)=> f.messages.length>0);
    if(flrMsg.length==1) {
      return true
    } else {
      return !isLast
    }
  }

  deleteCommentToClose() {
    this.commentsNotesService.modalData['hash'] = this.hashtags;
    this.dialogRef.close(this.commentsNotesService.modalData);
  }
  
  checkAllHaveTheMessages(group:any) {
    if(!group?.length) return true;

    let data = group.find((f:any)=> f.messages.length>0)
    return data ? false : true; 
  }

  groupTheMessages(data:any) {
    if(data?.length==0) return [];
    return _.orderBy(data, ['insert_timestamp'], ['desc']);
  }

  stateForToggle(pageIdx:any, i:any, idx:any) {
    const key = `toggle-${pageIdx}`;
    this.stateForToggleObj[key] = !this.stateForToggleObj[key];
  }
   
  returnData(pageIdx:any, i:any, idx:any) {
    return `group-${pageIdx}-${i}-${idx}`;
  }
  
  toggleReturnData(pageIdx:any) {
    return `toggle-${pageIdx}`;
  }
  
  @ViewChild('editTextArea') editTextArea!: ElementRef;

  editComment($event: MouseEvent,message: any,i: number,idx: number) {
    this.editedValue = message.comments;
    this.editIndex = i+'-'+idx
    this.editEnabled = true;
    setTimeout(() => {
      this.editTextArea?.nativeElement.focus();
    }, 0);
  }

  deleteComment($event: MouseEvent,message: any,i: number,idx: number) {
    this.editEnabled = false;
    let dialogRef = this.dialog.open(PopupDeleteComponent, {
      maxWidth: '90vw',
      disableClose: true,
      hasBackdrop: false,
      panelClass: "du-custom-modalbox",
      data:'comment'
    });

    dialogRef.afterClosed().subscribe((value) => {
      
      if(value == '1') {
        this.deleteCommentApi(message.user_comments_key, i, idx)
      }
    }); 
  }

  deleteCommentApi(key:any, i:any, idx:any) {
    let postdata: any = {
      "report_typ": "D",
      "user_comments_key" : key
    };
    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      this.findIdxRemove(i, idx);
      this.commentsNotesService.modalData['D'].push(postdata);
    }, (err:any) => {
      this.editedValue = '';
      this.editEnabled = false;
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
    }));
  }

  findIdxRemove(i:any, idx:any) {

    if (this.groupedMessages[i]) {
      
      // Use Lodash to remove the element at `idx` in the `message` array
      _.pullAt(this.groupedMessages[i].messages, idx);
  
      // If the `message` array is empty, remove the main object
      if (_.isEmpty(this.groupedMessages[i].messages)) {
        _.pullAt(this.groupedMessages, i);
      }
    }
    
  }

  getMSGHtml(data:any){
    data = data.replaceAll('\n','<br>')
    return data
  }
  
  saveEdit($event:any, message:any, i:any, idx:any) {
    if(!this.editedValue) return;

    let postdata: any = {
      "report_typ": "U",
      "comments": this.editedValue,
      "user_comments_key" : message.user_comments_key
    };

    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {

      this.groupedMessages[i].messages[idx]['comments'] = postdata.comments;
      this.groupedMessages[i].messages[idx]['update_timestamp'] = moment().format('MM-DD-YYYY');
      
      postdata['update_timestamp'] = moment().format('MM-DD-YYYY');
      this.commentsNotesService.modalData['U'].push(postdata);

      this.editedValue = '';
      this.editEnabled = false;

    }, (err:any) => {
      this.editedValue = '';
      this.editEnabled = false;
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
    }));
  }

  remove(hash: string): void {
    const index = this.hashtags.indexOf(hash);
    
    if (index >= 0) {
      this.hashtags.splice(index, 1);
      
      let fndHashTag = this.paramsData?.hashtags.find((f:any)=> f.hashtag_type + " - " + f.hashtag_key == this.paramsData?.key);
      fndHashTag['hashtag_value'] = this.hashtags.toString();
      let updateKey = fndHashTag?.hash_tag_dtls_key || null;

      this.updateTheHashTags(this.hashtags.toString(), updateKey)
    }
  }

  updateTheHashTags(hashTag:any, updateKey:any) {
    
    if(updateKey) {
      let postdata: any = { 
        "module_key": this.dashboardService?.moduleKey || '',
        "dashboard_key": this.paramsData?.dashboardKey || '',
        "brand_key" : this.filterService?.baseQuery?.brand_key,
        "hashtag_value": hashTag,
        "hash_tag_dtls_key": updateKey
      };
  
      this.hashtagService.updateHashTags(postdata).subscribe((res:any)=> {
      })
    }
  }
  
  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}
